import React from 'react';
import StopItem from './StopItem';
import './index.scss';
import { StopListItem } from '../../utils/formatType';
import { isEmpty } from '../../utils';
type IProps = {
  stopList: StopListItem[];
  vehicleId: string | number;
  vehicleName: string;
  scheduleState: string;
  handleStopClick: AnyFunc;
  handleScheduleModel: AnyFunc;
};

const EasyRoadMap = (props: IProps) => {
  return (
    <div className='road-map-container'>
      {isEmpty(props.stopList) ? (
        <div className='empty-view'>
          <div className='empty-line'></div>
          <div className='empty-text'>暂时没有待完成任务～</div>
        </div>
      ) : (
        <>
          {props.stopList.map((item, index) => (
            <StopItem
              {...item}
              vehicleId={props.vehicleId}
              key={index + '_' + item.id}
              hasProcessLine={index > 0}
              isFirstOrLast={index === 0 || index === props.stopList.length - 1}
              isLast={index === props.stopList.length - 1}
              handleClick={props.handleStopClick}
              handleScheduleModel={() => {
                props.handleScheduleModel();
              }}
            />
          ))}
        </>
      )}
    </div>
  );
};

export default React.memo(EasyRoadMap);
